/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface UserCompany
 */
export interface UserCompany {
  /**
   *
   * @type {number}
   * @memberof UserCompany
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof UserCompany
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof UserCompany
   */
  name?: string;
}

/**
 * Check if a given object implements the UserCompany interface.
 */
export function instanceOfUserCompany(value: object): value is UserCompany {
  return true;
}

export function UserCompanyFromJSON(json: any): UserCompany {
  return UserCompanyFromJSONTyped(json, false);
}

export function UserCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UserCompany {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    key: json['key'] == null ? undefined : json['key'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function UserCompanyToJSON(value?: UserCompany | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    key: value['key'],
    name: value['name'],
  };
}
